import { useTranslation } from '../i18n'
import { COLORS } from '../lib/theme'

/**
 * The "Estate" tag shown wherever a team appears (the team card, the team header,
 * the plan-hunt picker), so an estate is recognisable at a glance. The label is one
 * shared string in the `common` namespace, the same place the role labels live.
 *
 * `onDark` switches to the near-white plate the role pill uses on a team card photo,
 * so the two pills read the same on a dark image; otherwise it is a muted chip that
 * sits on a light surface.
 */
export function EstateTag({ onDark = false }: { onDark?: boolean }) {
  const { t } = useTranslation('common')
  const label = t('estate')
  if (onDark) {
    return (
      <span className="wh-chip" style={{ background: 'rgba(255,255,255,0.92)', color: COLORS.onPrimaryFixed }}>
        {label}
      </span>
    )
  }
  return <span className="wh-chip muted">{label}</span>
}
